var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgUpvoteFill = function SvgUpvoteFill(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "upvote_fill_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#upvote_fill_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.032 12.722v5.125a1 1 0 0 1-1 1H9.95a1 1 0 0 1-1-1v-5.125H5.013a.01.01 0 0 1-.008-.017l6.612-7.438a.5.5 0 0 1 .747 0l6.612 7.438a.01.01 0 0 1-.008.017h-3.936Zm-7.583 1.5H5.013c-1.303 0-1.994-1.54-1.129-2.513l6.612-7.438a2 2 0 0 1 2.99 0l6.611 7.438c.866.974.174 2.513-1.129 2.513h-2.436v3.625a2.5 2.5 0 0 1-2.5 2.5H9.95a2.5 2.5 0 0 1-2.5-2.5v-3.625Z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M19.5 12.938 12 4.5l-7.5 8.438h4.241L8.5 19.5h6.759v-6.563H19.5Z"
  }))));
};
export default SvgUpvoteFill;